import { createEvent, createStore, type EventCallable } from 'effector';
import type { ParseKeys } from 'i18next';

/**
 * Transient notifications (bottom-left), usually confirming a destructive action with Undo.
 * Messages are i18n keys + params so models stay language-agnostic; the toaster translates.
 */
export interface Toast {
  id: number;
  message: ParseKeys;
  params?: Record<string, string | number>;
  action?: { label: ParseKeys; event: EventCallable<void> };
  tone?: 'neutral' | 'error';
}

export const toastShown = createEvent<Omit<Toast, 'id'>>();
export const toastDismissed = createEvent<number>();

let nextId = 1;

/** At most three toasts; the newest replaces the oldest. */
export const $toasts = createStore<Toast[]>([])
  .on(toastShown, (list, toast) => [...list, { ...toast, id: nextId++ }].slice(-3))
  .on(toastDismissed, (list, id) => list.filter((t) => t.id !== id));
